// This file contains all relevant JS functionality for the "brands page" - https://www.dpj.se/brands
const sel = {
    navRune: ".brands-navigation__rune",
    NavAll: "#brands-navigation__rune--ALL",
    group: ".brands-listing__group",
}

const cssClass = {
    navRuneActive: "brands-navigation__rune--active",
    navRuneDisabled: "brands-navigation__rune--disabled",
    groupDisabled: "brands-listing__group--disabled",
    groupHidden: "brands-listing__group--hidden"
}
export const brands = {
    navRunes: [], // NodeList of all navigation runes
    groups: [], // NodeList of all brand groups (grouped by first char)
    init: () => {
        console.debug("brands.js: init");
        brands.navRunes = document.querySelectorAll(sel.navRune)
        brands.groups = document.querySelectorAll(sel.group)

        brands.disableEmptyGroups()
        brands.navRunes.forEach(brands.addNavRuneListener)

    },

    addNavRuneListener: (el) => {
        if (el.classList.contains(cssClass.navRuneDisabled)) return

        el.addEventListener("click", (e) => {
            const rune = e.target.getAttribute("data-rune")
            brands.navSetActive(rune)
            if (rune === "ALL") {
                brands.showAll()
            } else {
                brands.show(rune)
            }
        })
    },
    disableEmptyGroups: () => {
        const emptyGroups = []
        brands.groups.forEach(group => {
            const groupSize = group.children[1].children.length
            if (groupSize < 1) {
                emptyGroups.push(group.getAttribute("data-rune"))
            }

        })
        emptyGroups.forEach(rune => {
            const selNavRune = "#brands-navigation__rune--" + rune
            const navRune = document.querySelector(selNavRune)
            navRune.classList.add(cssClass.navRuneDisabled)

            const selGroup = "#brand-listing__group--" + rune
            const group = document.querySelector(selGroup)
            group.classList.add(cssClass.groupDisabled)
        })
    },
    navSetActive: (rune) => {
        brands.navRunes.forEach(navRune => {
            navRune.classList.remove(cssClass.navRuneActive)
        })
        const selector = "#brands-navigation__rune--" + rune;
        document.querySelector(selector).classList.add(cssClass.navRuneActive)
    },

    show: (rune) => {
        brands.groups.forEach(navRune => {
            navRune.classList.add(cssClass.groupHidden)
        })
        const selector = "#brand-listing__group--" + rune
        document.querySelector(selector).classList.remove(cssClass.groupHidden)

    },

    showAll: () => {
        brands.groups.forEach(navRune => {
            navRune.classList.remove(cssClass.groupHidden)
        })
    },


}

